// extracted by mini-css-extract-plugin
export default {"card":"PokemonCard_card__BAA-r","img":"PokemonCard_img__84DrK","name":"PokemonCard_name__9M6FW","description":"PokemonCard_description__1rOdY"};